const sessionTimes = {
  MIN_10: 600,
  MIN_20: 1200,
  MIN_30: 1800,
  MIN_45: 2700,
  MIN_60: 3600,
};

module.exports = sessionTimes;
